import React, { useState } from 'react';
import { changePassword, getToken, setSession } from '../services/api';

const ChangePassword = ({ usuario, onPasswordChanged, onLogout }) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!currentPassword) {
      setError('Ingresa la contraseña temporal.');
      return;
    }
    if (!newPassword) {
      setError('Ingresa una nueva contraseña.');
      return;
    }
    if (!confirmPassword) {
      setError('Confirma la nueva contraseña.');
      return;
    }
    if (newPassword.length < 12) {
      setError('La nueva contraseña debe tener al menos 12 caracteres.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('La confirmación no coincide con la nueva contraseña.');
      return;
    }
    if (currentPassword === newPassword) {
      setError('La nueva contraseña debe ser distinta a la temporal.');
      return;
    }

    setLoading(true);
    try {
      const data = await changePassword(currentPassword, newPassword);
      setSession(getToken(), data.usuario);
      onPasswordChanged(data.usuario);
    } catch (err) {
      setError(err.message || 'No se pudo cambiar la contraseña.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="gv-main gv-fade-in">
      <section className="gv-password-required">
        <div className="gv-card gv-password-required__card">
          <div className="gv-password-required__brand">
            <img src="/logo-gv-azul-color.png" alt="GasValpo + energias" />
            <span>Acceso temporal</span>
          </div>

          <h1>Cambia tu contraseña</h1>
          <p>
            Hola {usuario?.nombre || 'usuario'}, estás usando una clave temporal.
            Debes crear una contraseña personal antes de continuar.
          </p>

          {error && (
            <div className="gv-alert gv-alert--error">
              {error}
            </div>
          )}

          <form noValidate onSubmit={handleSubmit} className="gv-password-required__form">
            <div className="gv-form-group">
              <label className="gv-label">Contraseña temporal</label>
              <input
                type="password"
                className="gv-input"
                value={currentPassword}
                onChange={(event) => setCurrentPassword(event.target.value)}
                autoComplete="current-password"
                required
              />
            </div>

            <div className="gv-form-group">
              <label className="gv-label">Nueva contraseña</label>
              <input
                type="password"
                className="gv-input"
                value={newPassword}
                onChange={(event) => setNewPassword(event.target.value)}
                autoComplete="new-password"
                placeholder="Mínimo 12 caracteres"
                required
              />
            </div>

            <div className="gv-form-group">
              <label className="gv-label">Confirmar nueva contraseña</label>
              <input
                type="password"
                className="gv-input"
                value={confirmPassword}
                onChange={(event) => setConfirmPassword(event.target.value)}
                autoComplete="new-password"
                required
              />
            </div>

            <button type="submit" className="gv-btn gv-btn--primary gv-btn--full gv-btn--lg" disabled={loading}>
              {loading ? 'Actualizando...' : 'Guardar y continuar'}
            </button>

            <button type="button" className="gv-btn gv-btn--ghost gv-btn--full" onClick={onLogout}>
              Salir
            </button>
          </form>
        </div>
      </section>
    </main>
  );
};

export default ChangePassword;
